import EBTPaymentElement from './EBTPaymentElement';

export default EBTPaymentElement;
